<script setup lang="ts">
import { useRouter } from 'vue-router';

const router = useRouter();
const goAdmin = () => {
    router.push({ name: 'admin-top' });
};
</script>

<template>
    <v-container class="d-flex flex-column align-center justify-center fill-height">
        <h1 class="text-h1 font-weight-bold text-grey-darken-1">500</h1>
        <p class="text-h6 text-grey-darken-1 mb-6">サーバーエラーが発生しました</p>
        <v-btn color="primary" variant="outlined" @click="goAdmin"> 管理画面TOPに戻る </v-btn>
    </v-container>
</template>
